import { styled } from 'styled-components';
import { BonusItem } from '@/flat-pages/bonuses/ui/styles';

const BonusItemSkeleton = styled(BonusItem)`
  background: none;
`;

export { BonusItemSkeleton };
